<div class="bg-gradient-to-br from-lime-900 via-black to-black px-4 py-4 text-white">
<div
  class="flex flex-col items-center space-y-14 py-8"
>
  <div class="flex flex-col items-center space-y-4">
    <div class="text-3xl font-bold">
      Welcome to the audit mission tracking tool
    </div>

    <div class="text-center text-gray-300">
      <span class="block"
        >This tool allows you to follow the progress of your missions in real time and to interact with all stakeholders.</span
      >
      <span class="block"
      >Below you can see the current stats on your mission list</span
    >
    </div>
  </div>

 
  <button *ngIf="false"
    (click)="goToProjectCreate()"
    class="flex items-center space-x-2 bg-primary-accessible-green px-6 py-4 font-bold text-white duration-200 ease-in-out hover:bg-primary-green-6 focus:outline-none focus:ring-2 focus:ring-primary-dttl-green"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
        clip-rule="evenodd"
      />
    </svg>

    <span class="block">Perform a Mission</span>
  </button>
</div>



<div class="relative -bottom-25"> <app-projects-kpis></app-projects-kpis></div>

</div>





<div class="flex items-end mb-4">
  <h1 class="mt-8 text-3xl font-semibold text-gray-900">Latest Missions</h1>
  <div class=" col-span-2 flex items-center justify-end space-x-1 text-md px-4" *ngIf="loading">
    <div>
    <svg aria-hidden="true" class="w-5 h-5 mr-1 text-gray-200 animate-spin dark:text-gray-600 fill-green-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>  
    </div>

    <h2 class="block "> Loading  ... </h2>
  </div>
  <div class="grow"></div>
  <div class="w-1/4">
    <app-search-bar 
    (onKeywordEntered)="applySearch($event)"
    ></app-search-bar>  

  </div>
</div>



<app-empty-list-message *ngIf="emptyListOfMissionsWithoutFilters"> You don't have any missions yet</app-empty-list-message>

<div class="mt-4 flex flex-col" *ngIf="paginatedMissions && !emptyListOfMissionsWithoutFilters">
  <div class="-mx-4 overflow-x-auto">
    <div class="inline-block min-w-full py-2 px-4 align-middle">
      <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5">
        <table class="min-w-full divide-y divide-gray-300">
          <thead class="bg-gray-50">
            <tr
              header
              app-project-table-header
              (onMissionStatusFilterApplied)="applyFilters('statut__in', $event)"
              (onSousGroupesFilterApplied)="applyFilters('sous_groupes__id__in', $event)"


            ></tr>
          </thead>

          <tbody class="divide-y divide-gray-200 bg-white">
            <tr
              app-project-item-tr
              *ngFor="let mission of paginatedMissions.results"
              class="group cursor-pointer hover:bg-gray-100 align-middle"
              [ngClass]="{'bg-red-100 hover:bg-red-200 border-y border-red-200': isStartDateExpiredAndMissionNotTerminated(mission)}"
              (click)="goToProject(mission.id)"
              [mission]="mission"
              [isStartExpired]="isStartDateExpiredAndMissionNotTerminated(mission)"
            ></tr>


          </tbody>

        </table>
        <app-no-search-result-message *ngIf="emptyListOfMissionsWithFilters"></app-no-search-result-message>

      </div>
    </div>
  </div>


  

  <app-pagination
    [pagination]="paginatedMissions"
    (onSwitchPage)="switchPage($event)"
    classes="mt-4"
  ></app-pagination>
</div>




